import React, { useMemo } from 'react'
import { CardContext } from 'dataProviders/Card'

type Props = {
  cardId: number
}

const ModalCardContext: React.FC<Props> = ({
  children,
  cardId,
}) => {
  const cardContextValue = useMemo(() => ({
    id: cardId || 0
  }), [cardId])

  return (
    <CardContext.Provider value={cardContextValue}>
      {children}
    </CardContext.Provider>
  )
}

export default ModalCardContext
